// @flow

import React, { useEffect } from 'react';
import type { Node } from 'react';
import { fetchGames } from './actions';
import './App.css';
import GameRow from './GameRow';

import { useDispatch, useSelector } from 'react-redux';

const useFetching = (someFetchActionCreator: () => any) => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(someFetchActionCreator());
  }, []);
}

function App(): Node {
  useFetching(fetchGames);
  const games = useSelector(state => state.games);
  const game_components = games.map((game) => <GameRow game={game} />);
  return (
    <div className="App">
      <div className="PageTitle">Civilization VI Game Status</div>
      <div className="App-header">
        {game_components}
      </div>
    </div >
  );
}

export default App;
